import { Stack } from '@mui/material';

import {
  PARTNER_COMPANIES_CONTRACT_STATUS_NAME,
  PartnerCompaniesContractStatusEnum,
} from '@constants';
import { PartnerCompanyStatusChip } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/components/PartnerCompaniesStatusChip';

export const mappedPartnerStatus = (
  partnerCompanyStatus: PartnerCompaniesContractStatusEnum,
) => {
  const content = (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <PartnerCompanyStatusChip
        fontSize="12px"
        status={partnerCompanyStatus}
        size="small"
      />
    </Stack>
  );

  return {
    label: PARTNER_COMPANIES_CONTRACT_STATUS_NAME[partnerCompanyStatus],
    value: partnerCompanyStatus,
    content,
  };
};
